enum ClaimTypeEnum {
  CASUALTY = 'casualty',
  COMPREHENSIVE = 'comprehensive',
  DEBT_COLLECTION = 'debtCollection',
  DELIVERY = 'delivery'
}

export default ClaimTypeEnum;
